import React from 'react'
import { motion } from "framer-motion"
import { Link } from "react-router-dom";


function ContactSection() {
    return (
        <>
            {/* Transform IT Section */}
            <section className="transform-it-section pb-5 pt-3">
                <div className="container">
                    <motion.div
                        className="transform-card position-relative rounded-4 overflow-hidden"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                        style={{ minHeight: '400px', borderRadius: '20px' }}
                    >
                        {/* Background Image */}
                        <div
                            className="position-absolute top-0 start-0 w-100 h-100"
                            style={{
                                backgroundImage: `url('https://images.unsplash.com/photo-1573164713988-8665fc963095?q=80&w=1200&auto=format&fit=crop')`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center 30%',
                            }}
                        ></div>

                        {/* Gradient Overlay for text readability */}
                        <div
                            className="position-absolute top-0 start-0 w-100 h-100"
                            style={{
                                background: 'linear-gradient(to right, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0) 100%)'
                            }}
                        ></div>

                        {/* Content */}
                        <div className="position-relative h-100 d-flex align-items-center p-5">
                            <div className="content-wrapper ms-md-4" style={{ maxWidth: '500px' }}>
                                <h2 className="fw-bold text-white mb-4" style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)', lineHeight: '1.2' }}>
                                    Transform IT.<br />
                                    Empower Growth.
                                </h2>

                                <Link to="/contact" className="d-inline-flex bg-white rounded-pill p-1 ps-4 pe-2 align-items-center text-decoration-none shadow" style={{ transition: 'transform 0.3s ease' }} onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'} onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                                    <span className="text-dark fw-bold me-3" style={{ fontSize: '1rem' }}>Get In Touch</span>
                                    <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ backgroundColor: '#3b82f6', width: '40px', height: '40px' }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 17L17 7M17 7H7M17 7V17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </section>
        </>
    )
}

export default ContactSection